import LandingPage from 'app/team/components/LandingPage';

const landingPageConfig = {
  ServerWrapper: LandingPage,
  doesRequireServerApp: true,
  isAuthAttemptRequired: true,
};

const asyncRoute = {
  routes: {
    '/teams': landingPageConfig,
    '/teams/early-access': landingPageConfig,
  },
};

export default asyncRoute;
